import { render, staticRenderFns } from "./invadjustfrm.vue?vue&type=template&id=fef4a31c"
import script from "./invadjustfrm.vue?vue&type=script&lang=js"
export * from "./invadjustfrm.vue?vue&type=script&lang=js"
import style0 from "./invadjustfrm.vue?vue&type=style&index=0&id=fef4a31c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports